import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/';
import {PrismHeaders} from '../enums';

@Injectable({
    providedIn: 'root'
})
export class MemberService {
    constructor(private http: HttpClient) {
    }

    getMember(updateData?) {
        const headers = new HttpHeaders()
            .set(PrismHeaders.UpdateCacheData, JSON.stringify({updateData}));
        return this.http.get(environment.apiBaseUrl + '/member-get-member', {headers});
    }

    updateMember(body) {
        return this.http.put(environment.apiBaseUrl + '/member-put-member', body);
    }

    getCompanyLogoUploadUrl(body: { contentType: string; fileName: string; contentLength?: number }) {
        return this.http.post(environment.apiBaseUrl + '/member-get-company-logo-upload-url', body);
    }

    uploadCompanyLogo(uploadUrl: string, file: File) {
        return this.http.put(uploadUrl, file);
    }
}
